<template>
<div class="chapter">
<div class="inner_page">
<div style="display:none;"><a id="GBS.PA1.w.1.1.0"></a></div>
<div class="flow" style="">
<div class="gtxt_body" id="block.18.1.0.box.538.1044.567.141.q.100">
<a id="ORIG-GBS.PA1.w.1.0.0"></a><p class="gtxt_body gtxt_heading" id="para.18.1.0.box.750.1044.135.38.q.100" style="text-align:center;">Part I</p>
<a id="ORIG-GBS.PA1.w.1.1.0"></a><p class="gtxt_body gtxt_heading" id="para.18.1.1.box.538.1142.567.43.q.90" style="text-align:center;"><a id="GBS.PA2"></a><a id="GBS.PA2.w.0.0.0"></a>PLANTATION PEOPLE</p>
</div>
</div><div style="display:none;"><a id="GBS.PA3"></a><a id="GBS.PA3.w.0.0.0"></a><a id="GBS.PA3.w.1.0.0"></a></div>
<div style="display:none;"><a id="GBS.PA3.w.1.0.0.1"></a></div><div style="display:none;"><a id="GBS.PA3.w.1.0.0.2"></a></div><div class="flow" style="">
</div>
<div class="flow" style="">
<div class="pagebreak"></div>
<a class="page" id="ORIG-GBS.PA3"></a>
<div class="gimg_graphic" id="block.20.0.0.box.330.336.1076.684.q.101">
<a id="GBS.PA3.w.1.0.0.3"></a><img alt="[graphic]" src="data/content-0009.png" style="max-width:100%; max-height:100%"/><a id="GBS.PA3.w.1.0.0.4"></a></div>
</div>
<div style="display:none;"><a id="GBS.PA3.w.1.0.0.5"></a></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// content0010.vue?98aae5ba